/* eslint-disable import/no-cycle */
import LintasAPIService from '../../APIServices/lintasapi';
import { showToast } from '../../Utils/index'
import {
  ALL_SITES,
  GET_VENDOR_USERS,
  VENDOR_ASSIGN,
  ASSIGN_FREQUENCY, UPDATE_PRIMARY_QUERY, UPDATE_SEARCH_QUERY, GET_FILTERS,
  GET_SITE_REPORTS,
  UPDATE_SITE_REPORTS,
  UPDATE_SITE,
  REMOVE_MAPPING,
  REMOVE_FREQUENCY,
  ASSIGN_FLEX_RECEIVE_DATE,
  DELETED_SITES,
  UPDATE_ALL_SITE_DATA,
  UPDATE_AUDITOR_SITES,
  // UPDATE_ADMIN_SITE,
} from '../actionTypes';
import { handleErrorLocal, loader } from './common';

const apiCall = new LintasAPIService();

export const updatePrimaryQuery = (query) => (dispatch) => {
  dispatch({
    type: UPDATE_PRIMARY_QUERY,
    payload: query,
  })
};

export const updateSearchQuery = (query) => (dispatch) => {
  dispatch({
    type: UPDATE_SEARCH_QUERY,
    payload: query,
  })
};

export const getAllSites = (page, primaryQuery, searchQuery) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getAllSites({ page, primaryQuery, searchQuery })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const getFilterSitesByAuditorAction = (
  page, primaryQuery, searchQuery, status,
) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getAllSitesFiter({
      page, primaryQuery, searchQuery, status,
    })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const getVendorUsers = (supplierId) => (dispatch) => {
  apiCall
    .getVendorUsers(supplierId)
    .then((response) => dispatch({
      type: GET_VENDOR_USERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
};

export const assignVendorToSite = (data) => (dispatch) => {
  apiCall
    .assignVendorToSite(data)
    .then((response) => {
      showToast('success', response.data.message)
      dispatch({
        type: VENDOR_ASSIGN,
        payload: response.data,
        data,
      })
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
};

export const assignFrequencyToSites = (data) => (dispatch) => {
  apiCall
    .assignFrequencyToSites(data)
    .then((response) => {
      showToast('success', response.data.message)
      dispatch({
        type: ASSIGN_FREQUENCY,
        payload: response.data,
        data,
      })
    })
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
};

export const getFilters = () => (dispatch) => {
  apiCall
    .getFilters()
    .then((response) => dispatch({
      type: GET_FILTERS,
      payload: response.data,
    }))
    .catch((err) => {
      dispatch(handleErrorLocal(err))
    });
};

export const getSiteReportsBySiteId = (siteId) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getSiteReportsBySiteId(siteId)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: GET_SITE_REPORTS,
        payload: response.data,
        siteId,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const approveRejectSiteReport = (data, siteReportId, siteId) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .approveRejectSiteReport(data, siteReportId)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: UPDATE_SITE_REPORTS,
        payload: response.data.data,
        siteReportId,
        siteId,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const getSitesDataByEstimateId = (estimateId) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getSitesDataByEstimateId(estimateId)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
      dispatch({
        type: GET_FILTERS,
        payload: response.data.filters,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const notifyMonitor = (id) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .notifyMonitor(id)
    .then(() => {
      dispatch(loader(false))
      showToast('success', 'Notification sent successfully')
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const changeStartDate = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .changeStartDate(data)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: UPDATE_SITE,
        payload: data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const removeMapping = (id) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .removeMapping(id)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: REMOVE_MAPPING,
        payload: id,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const changeReportDate = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .changeReportDate(data)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: UPDATE_SITE_REPORTS,
        payload: response.data.data,
        siteReportId: data.siteReportId,
        siteId: data.siteId,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const removeFrequency = (id) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .removeFrequency(id)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: REMOVE_FREQUENCY,
        payload: id,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const assignFlexReceiveDate = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .assignFlexReceiveDate(data)
    .then(() => {
      dispatch(loader(false))
      showToast('success', 'Flex date assigned successfully')
      dispatch({
        type: ASSIGN_FLEX_RECEIVE_DATE,
        payload: data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

export const getVendorSites = (page, searchQuery) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getVendorSites({ page, searchQuery })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const updateSiteLinkForReport = (data, siteId) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .updateSiteLinkForReport(data, siteId)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: UPDATE_ALL_SITE_DATA,
        payload: { data: response.data.data, siteId },
      })
      showToast('success', response.data.message)
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const getDeletedSitesByEstimateId = (estimateId) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getDeletedSitesByEstimateId(estimateId)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
      dispatch({
        type: GET_FILTERS,
        payload: response.data.filters,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const mapDeletedSiteData = (id) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .mapDeletedSiteData(id)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: DELETED_SITES,
        payload: id,
      })
      showToast('success', response.data.message)
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const mapEstimateDeletedSiteData = (id) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .mapEstimateDeletedSiteData(id)
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: DELETED_SITES,
        payload: id,
      })
      showToast('success', response.data.message)
      dispatch(getDeletedSitesByEstimateId(id));
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const createNewTask = (id, taskDate) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .createNewTask(id, taskDate)
    .then((response) => {
      dispatch({
        type: GET_SITE_REPORTS,
        payload: response.data,
        siteId: id,
      })
      showToast('success', response.data.message)
      dispatch(loader(false))
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const getAllDeletedSites = (page, primaryQuery, searchQuery) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .getAllDeleteSites({ page, primaryQuery, searchQuery })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const changeEndDate = (data) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .changeEndDate(data)
    .then((response) => {
      dispatch(loader(false))
      showToast('success', response.data.message)
      dispatch({
        type: UPDATE_SITE,
        payload: data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
}

// eslint-disable-next-line max-len
export const updateSitesAuditorVisibility = (siteIds, page, primaryQuery, searchQuery) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .updateSitesAuditorVisibility({
      siteIds, page, primaryQuery, searchQuery,
    })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: ALL_SITES,
        payload: response.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const updateSiteActionableItem = (
  siteId, itemId, action, reason = '',
) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .updateSiteActionableItem({
      siteId, itemId, action, reason,
    })
    .then((response) => {
      dispatch(loader(false))
      dispatch({
        type: UPDATE_AUDITOR_SITES,
        payload: response.data.data,
      })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};

export const updateSiteActionableItemAdmin = (
  siteId, itemId, action, reason = '',
) => (dispatch) => {
  dispatch(loader(true))
  apiCall
    .updateSiteActionableItem({
      siteId, itemId, action, reason,
    })
    .then(() => {
      dispatch(loader(false))
      // dispatch({
      //   type: UPDATE_ADMIN_SITE,
      //   payload: response.data.data,
      // })
    })
    .catch((err) => {
      dispatch(loader(false))
      dispatch(handleErrorLocal(err))
    });
};
